export default __webpack_public_path__ + "static/media/femimed_korytarz_2_thumbnail.45a8e389.webp";